import React from "react";
import { NavLink } from "react-router-dom";
import { Activity, ClipboardList, Radio, CheckSquare, Trophy, QrCode, Award } from "lucide-react";

const TABS = [
  { seg: "live", label: "Live Dashboard", icon: Activity },
  { seg: "bulk-entry", label: "Bulk Entry", icon: ClipboardList },
  { seg: "station", label: "Station Mode", icon: Radio },
  { seg: "checkin", label: "Check-In", icon: CheckSquare },
  { seg: "selection", label: "Top 40 Selection", icon: Trophy },
  { seg: "recognition", label: "Recognition Engine", icon: Award },
  { seg: "credentials", label: "Credentials & QR", icon: QrCode },
];

export default function CampOpsNav({ campId }) {
  return (
    <div className="flex flex-wrap gap-2 border-b border-slate-200 pb-3 mb-6">
      {TABS.map((t) => (
        <NavLink
          key={t.seg}
          to={`/admin/camps/${campId}/${t.seg}`}
          data-testid={`campops-nav-${t.seg}`}
          className={({ isActive }) =>
            `inline-flex items-center gap-2 px-4 py-2 text-xs font-semibold uppercase tracking-wider rounded-sm ${
              isActive ? "bg-[#E63946] text-white" : "bg-white border border-slate-300 text-[#0A192F] hover:bg-slate-50"
            }`
          }
        >
          <t.icon className="w-4 h-4" /> {t.label}
        </NavLink>
      ))}
    </div>
  );
}
